<!-- headlessUIにはtoastが存在しないので、別のOSSであるnotiwindを利用する。
     https://github.com/emmanuelsw/notiwind  -->
<template>

  <!-- 右上に出すトースト -->
  <NotificationGroup group="top-right">
    <!--このdivでベースの位置を制御している。groupごとに表示位置を決めている -->
    <div class="fixed inset-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none">

      <div class="w-full max-w-sm">
        <Notification
            v-slot="{ notifications, close }"
            enter="ease-out duration-300 transition"
            enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
            enter-to="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-500"
            leave-from="opacity-100"
            leave-to="opacity-0"
            move="transition duration-500"
            move-delay="delay-300"
        >
          <div
              class="w-full max-w-sm mt-4 overflow-hidden bg-white rounded-lg shadow-lg pointer-events-auto ring-1 ring-black ring-opacity-5"
              v-for="notification in notifications"
              :key="notification.id"
          >
            <ZNotificationCard :close="close" :notif="notification"/>
          </div>
        </Notification>
      </div>
    </div>
  </NotificationGroup>

  <!-- 右下に出すトースト -->
  <NotificationGroup group="bottom-right" position="bottom">
    <div class="fixed inset-x-0 bottom-0 flex items-start justify-end p-6 px-4 py-6 pointer-events-none">
      <div class="w-full max-w-sm">
        <Notification
            v-slot="{ notifications, close }"
            enter="ease-out duration-300 transition"
            enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
            enter-to="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-500"
            leave-from="opacity-100"
            leave-to="opacity-0"
            move="transition duration-500"
            move-delay="delay-300"
        >
          <div
              class="w-full max-w-sm mt-4 overflow-hidden bg-white rounded-lg shadow-lg pointer-events-auto ring-1 ring-black ring-opacity-5"
              v-for="notification in notifications"
              :key="notification.id"
          >
            <ZNotificationCard :close="close" :notif="notification"/>
          </div>
        </Notification>
      </div>
    </div>
  </NotificationGroup>

  <!-- 下に出すトースト -->
  <NotificationGroup group="bottom">
    <div class="fixed inset-x-0 bottom-0 flex items-start justify-center p-6 px-4 py-6 pointer-events-none z-50">
      <div class="w-full max-w-sm">
        <Notification
            v-slot="{ notifications, close }"
            enter="ease-out duration-300 transition"
            enter-from="translate-y-2 opacity-0"
            enter-to="translate-y-0 opacity-100"
            leave="transition ease-in duration-500"
            leave-from="opacity-100"
            leave-to="opacity-0"
            move="transition duration-500"
            move-delay="delay-300"
        >
          <div
              class="w-full max-w-sm mt-4 overflow-hidden bg-white rounded-lg shadow-lg pointer-events-auto ring-1 ring-black ring-opacity-5"
              v-for="notification in notifications"
              :key="notification.id"
          >
            <ZNotificationCard :close="close" :notif="notification"/>
          </div>
        </Notification>
      </div>
    </div>
  </NotificationGroup>

</template>


<script setup lang="ts">
import {
  Notification,
  NotificationGroup,
} from './zNotify';
import ZNotificationCard from './ZNotificationCard.vue';

</script>
